
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';

  @Component
  export default class GuestTable extends Vue {
    @Prop({type: String, default: ''}) private trainingId!: any;
    @Prop({type: Object, default: null}) private guest!: any;

    @Action('admin/trainings/removeGuest') private removeGuest!: any;
    @Action('admin/trainings/readGuests') private readTrainingGuests!: any;

    private dialog: boolean = false;
    private loading: boolean = false;

    private async remove() {
      this.loading = true;
      await this.removeGuest({trainingGuestId: this.guest.id, id: this.trainingId});
      await this.readTrainingGuests({id: this.trainingId});
      this.loading = false;
      this.dialog = false;
    }

    private cancel() {
      this.dialog = false;
    }
  }
